import { render } from "./ViewImg.vue?vue&type=template&id=51f9ad10&scoped=true"
import script from "./ViewImg.vue?vue&type=script&lang=js"
export * from "./ViewImg.vue?vue&type=script&lang=js"

import "./ViewImg.vue?vue&type=style&index=0&id=51f9ad10&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51f9ad10"]])

export default __exports__